export const AmplifyLogs: any = {
    accountDetails: {
        action: 'View Account Details button was clicked.',
        description: 'View Account Details button was clicked.'
    },
    paynowWidget: {
        action: 'Pay now button clicked',
        paymentHistoryLink: 'Pay history link clicked',
        viewStatementLink: 'View statement link clicked',
        autoPayLink: 'Auto pay link clicked',
        accSummary: 'Account Summary link clicked',
        learnMore: 'Payoff Quote / Wire Transfer learn more link clicked',
        accountDetailAction: 'View Account Details button was clicked',
        accountDetailDescription: 'View Account Details button was clicked'
    },
    loanInprogressWidget: {
        action: 'ViewProgressbuttonclicked',
        description: 'View Progress button clicked in Loan In Progress Widget'
    },
    errPageHomeBtn: {
        type: 'Error Page home button',
        action: 'ErrorPageHomeButtonClicked',
        description: 'Home Button in Error Page Clicked'
    },
    errPageRedirection: {
        type: 'Error Page.',
        action: 'UserNavigatedToErrorPage.',
        description: 'User navigated to Error page.'
    },
    homeBtn: {
        type: 'Home button',
        action: 'HomeButtonIconClicked',
        description: 'Eagle Icon clicked in Home'
    },
    myProfile: {
        action: 'ManageProfileLinkClicked.',
        description: 'Manage Profile link clicked'
    },
    marketingWidget: {
        action: 'MarketingWidgetLinkClicked',
        description: 'Marketing widget link clicked'
    },
    purchaseWidget: {
        action: 'PurchaseWidgetLinkClicked',
        description: 'Purchase Widget link clicked'
    },
    promotionWidget: {
        action: 'MobileAppPromotionWidgetClicked.',
        description: 'Mobile app promotion widget clicked.'
    },
    idleTimerModal: {
        type: 'idle_timer_modal',
        action: 'StayInSessionButtonClicked',
        description: 'Stay in session button clicked'
    },
    eagleEyeWidget: {
        action: 'EagleEyeWidgetLinkClicked',
        description: 'Eagle eye widget link clicked'
    },
    FaqWidget: {
        action: 'FAQWidgetLinkClicked',
        description: 'FAQ widget link clicked'
    },
    DiyWidget: {
        action: 'DiyWidgetLinkClicked',
        description: 'Diy widget link clicked'
    },
    docErrAlertBtn: {
        type: 'Document error alert popup',
        description: 'Document error alert popup clicked',
        action: 'DocumentErrorAlertPopupClicked'
    },
    authCashOut: {
        type: 'Personalized CashOut Offer widget',
        description: 'Get Started link clicked in Personalized CashOut',
        action: 'GetStartedlinkclicked'
    },
    CashOutWidgetGeneric: {
        type: 'Generic CashOut Offer widget',
        description: 'Get Started link clicked',
        action: 'GetStartedLinkClicked'
    },
    purchase_widget: {
        type: 'Purchase offer widget',
        description: 'Get Started link clicked in Purchase offer Widget ',
        action: 'GetStartedlinkClicked'
    },
    authRefi: {
        type: 'Refinance offer widget',
        description: 'Get Started link clicked in Refinance offer Widget',
        action: 'GetStartedLinkClicked'
    },
    paperlessEnrolment: {
        type: 'Paperless Enrolment widget',
        description: 'Enroll now button clicked',
        action: 'EnrollNowButtonClicked'
    },
    turboTaxPopupDisplayed: {
        type: 'TurboTaxPopup',
        description: 'Turbo Tax Pop-up displayed via 1098 tile',
        action: 'TurboTaxPopupDisplayed'
    },
    turboTaxPopupClosed: {
        type: 'TurboTaxPopup',
        description: 'Turbo Tax Pop-up displayed via 1098 tile',
        action: 'TurboTaxPopupCloseClicked'
    },
    turboTaxPopupButtonClicked: {
        type: 'TurboTaxPopup',
        description: 'Turbo Tax Pop-up displayed via 1098 tile',
        action: 'TurboTaxPopupStartClicked'
    },
    turboTaxPopupDisplayedViaLogin: {
        type: 'TurboTaxPopup',
        description: 'Turbo Tax Pop-up displayed via login',
        action: 'TurboTaxPopupDisplayed'
    },
    turboTaxPopupButtonClickedViaLogin: {
        type: 'TurboTaxPopup',
        description: 'Turbo Tax Pop-up displayed via login',
        action: 'TurboTaxPopupStartClicked'
    },
    turboTaxPopupClosedViaLogin: {
        type: 'TurboTaxPopup',
        description: 'Turbo Tax Pop-up displayed via login',
        action: 'TurboTaxPopupCloseClicked'
    }
};
